import type { GetterTree } from 'vuex'
import type { RootState } from '@/store'
import type { LocationState, LocationCoords } from './types'
import { LOCATION_GETTERS, LocationError } from './types'

interface ILocationGetters extends GetterTree<LocationState, RootState> {
  [LOCATION_GETTERS.CURRENT_LOCATION](state: LocationState): LocationCoords
  [LOCATION_GETTERS.LOADING](state: LocationState): () => boolean
}

const getters: ILocationGetters = {
  [LOCATION_GETTERS.CURRENT_LOCATION](state): LocationCoords {
    if (state.allowed && !state.loading) {
      return { lat: state.lat, lng: state.lng }
    }
    if (state.allowed === false) {
      return { error: LocationError.DISALLOWED }
    }

    return { error: LocationError.UNKNOWN }
  },
  [LOCATION_GETTERS.LOADING](state): () => boolean {
    return () => state.loading
  }
}

export default getters
